import { Spinner } from "react-bootstrap";

function LoadingSpinner() {
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center my-5 py-5"
      style={{
        minHeight: "400px",
        backgroundColor: "rgba(255, 255, 255, 0.95)",
      }}
    >
      <Spinner
        animation="border"
        role="status"
        variant="dark"
        style={{ width: "5rem", height: "5rem", borderWidth: "0.4rem" }}
      >
        <span className="visually-hidden">Cargando...</span>
      </Spinner>
      <h3 className="mt-4 text-dark fw-bold">Consultando información...</h3>
      <p className="text-muted fs-5 mb-2">
        Por favor espere, la consulta puede tardar unos momentos
      </p>
      <p className="text-secondary fst-italic">
        El sistema está procesando los datos, no cierre esta ventana
      </p>
    </div>
  );
}

export default LoadingSpinner;
